var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"otp-button otp-button-white"},[_c('div',{staticClass:"otp-p-l"},[_c('div',{staticClass:"otp-logo"}),_c('strong',[_c('a',{attrs:{"data-fancybox":"","data-type":"iframe","href":_vm.creditUrl}},[_c('span',{staticClass:"otp-green"},[_vm._v(_vm._s(_vm.$t('paymentOTPBtn')))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }